export default __webpack_public_path__ + "static/media/nothing-found.2f098f38.png";